import {
    STORE_INVESTOR_TRACKER,
    STORE_LOCATION,
    REMOVE_LOCATION,
    STORE_PERSON,
    REMOVE_PERSON,
    STORE_SAVED_CONTRACTOR,
    REMOVE_SAVED_CONTRACTOR,
    STORE_CONTRACTOR_CATEGORIES,
} from '../../constants/investorTracker';

const initialState = {
    companies: [],
    people: [],
    locations: [],
    savedContractors: [],
    contractorCategories: [],
    currentPersonId: null,
};

const upsert = (list, item, key = 'id') => {
    const idx = list.findIndex((l) => l[key] === item[key]);
    if (idx === -1) return [...list, item];
    const next = list.slice();
    next[idx] = item;
    return next;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_INVESTOR_TRACKER:
            return {
                ...state,
                companies: action.payload?.companies || [],
                people: action.payload?.people || [],
                locations: action.payload?.locations || [],
                savedContractors: action.payload?.savedContractors || [],
                contractorCategories: action.payload?.contractorCategories || [],
                currentPersonId: action.payload?.currentPersonId || state.currentPersonId,
            };

        case STORE_CONTRACTOR_CATEGORIES:
            return {
                ...state,
                contractorCategories: action.contractorCategories || [],
            };

        case STORE_SAVED_CONTRACTOR:
            return {
                ...state,
                savedContractors: upsert(state.savedContractors, action.savedContractor, 'id'),
            };

        case REMOVE_SAVED_CONTRACTOR:
            return {
                ...state,
                savedContractors: state.savedContractors.filter((s) => s.id !== action.savedContractorId),
            };

        case STORE_LOCATION:
            return {
                ...state,
                locations: upsert(state.locations, action.location, 'id'),
            };

        case REMOVE_LOCATION:
            return {
                ...state,
                locations: state.locations.filter((l) => l.id !== action.locationId),
            };

        case STORE_PERSON:
            return {
                ...state,
                people: upsert(state.people, action.person, 'id'),
            };

        case REMOVE_PERSON:
            return {
                ...state,
                people: state.people.filter((p) => p.id !== action.personId),
            };

        default:
            return state;
    }
};
